<template lang="html">
  <div class="search-wrapper">
    <input
      type="text"
      class="input"
      @focusin="this.handleFocusIn"
      @focusout="this.handleFocusOut"
      :placeholder="placeholder"
      v-model="search"
      @change="setSearch(search)"
      v-on:keyup="setSearch(search)"
    />
    <div class="icon" v-on:click="setSearch(search)">
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M11.4601 10.6386L15.7639 14.9425C15.9151 15.0939 16.0001 15.2992 16 15.5132C15.9999 15.7272 15.9148 15.9324 15.7635 16.0837C15.6121 16.235 15.4068 16.3199 15.1928 16.3198C14.9788 16.3197 14.7736 16.2347 14.6223 16.0833L10.3185 11.7794C9.03194 12.7759 7.41407 13.2448 5.79403 13.0908C4.17398 12.9368 2.67346 12.1714 1.59771 10.9503C0.521957 9.72917 -0.0482098 8.1441 0.00319691 6.51752C0.0546036 4.89094 0.723722 3.34504 1.87443 2.1943C3.02514 1.04356 4.57101 0.374429 6.19754 0.323021C7.82408 0.271613 9.40911 0.841794 10.6302 1.91757C11.8513 2.99335 12.6167 4.49391 12.7707 6.114C12.9247 7.73408 12.4558 9.35199 11.4593 10.6386H11.4601ZM6.4003 11.5194C7.67328 11.5194 8.89412 11.0137 9.79425 10.1135C10.6944 9.21336 11.2001 7.99249 11.2001 6.71948C11.2001 5.44647 10.6944 4.2256 9.79425 3.32544C8.89412 2.42529 7.67328 1.91959 6.4003 1.91959C5.12732 1.91959 3.90648 2.42529 3.00634 3.32544C2.10621 4.2256 1.60052 5.44647 1.60052 6.71948C1.60052 7.99249 2.10621 9.21336 3.00634 10.1135C3.90648 11.0137 5.12732 11.5194 6.4003 11.5194Z"
          fill="white"
        />
      </svg>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    placeholder: String,
    setSearch: Function,
  },
  data() {
    return {
      search:'',
    }
  },
  methods: {
    handleFocusIn(e) {
      let wrapper = e.target.parentElement;
      wrapper.classList.add("pressed");
    },
    handleFocusOut(e) {
      let wrapper = e.target.parentElement;
      wrapper.classList.remove("pressed");
    },
  },
};
</script>
<style lang="css" scoped>
.search-wrapper {
  background: #ffffff;
  border: 2px solid #e0e0e1;
  box-sizing: border-box;
  border-radius: 25px;

  display: flex;
  flex-direction: row;
  align-items: center;
  overflow: hidden;
  padding-right: 4px;
}
.search-wrapper .input {
  width: 100%;
  border: none;
  padding: 12px 10px 12px 30px;
  outline: none;

  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 18px;
  color: #013652;

  transition: all 0.3s ease-in-out;
}

.search-wrapper .input::placeholder {
  color: #72696f;
}
.search-wrapper:hover .input {
  color: rgba(1, 54, 82, 0.8);
}

.search-wrapper .icon {
  background: radial-gradient(
    69% 69% at 50% 31%,
    rgba(51, 100, 126, 0.97) 0%,
    rgba(1, 54, 82, 0.97) 100%
  );
  border-radius: 25px;
  width: 40px;
  height: 40px;
  min-width: 40px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease-in-out;
}
.search-wrapper:hover .icon {
  background: radial-gradient(
    69% 69% at 50% 31%,
    rgba(51, 100, 126, 0.77) 0%,
    rgba(1, 54, 82, 0.77) 100%
  );
}

.search-wrapper.pressed {
  border: 2px solid #013652;
}
.search-wrapper.pressed .icon {
  background: radial-gradient(
    69% 69% at 50% 31%,
    rgba(28, 80, 107, 0.97) 0%,
    rgba(1, 54, 82, 0.97) 100%
  );
}
</style>
